import React from 'react';
import PropTypes from 'prop-types';

const ProceedToPaymentButton = ({onClick = () => {}}) => {
    return (

        <div className="actions__item">
            <button type="submit" onClick={(event) => {event.preventDefault(); onClick()}}
                className="button button__pay"
                id="submit-order-form"
                name="proceed-button">
                Proceed to Payment
                <div className="btn-loader center"><span></span></div>
            </button>
        </div>

    )
}

ProceedToPaymentButton.propTypes = {
    onClick: PropTypes.func,
};

export default ProceedToPaymentButton;